import React from 'react';
import { Badge } from '../ui/badge';

export const StatusBadge = ({ meta, status, testId }) => {
  const m = meta[status] || { label: status, cls: '' };
  return <Badge variant="outline" className={`text-[10px] font-medium whitespace-nowrap ${m.cls}`} data-testid={testId}>{m.label}</Badge>;
};

export const StatusChips = ({ meta, counts, value, onChange, testPrefix }) => {
  const total = Object.values(counts || {}).reduce((a, b) => a + b, 0);
  const options = [{ key: 'all', label: 'All', n: total }, ...Object.keys(meta).map((k) => ({ key: k, label: meta[k].label, n: counts?.[k] || 0 }))];
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          onClick={() => onChange(o.key)}
          className={`rounded-full border px-2.5 py-1 text-xs transition-colors duration-150 ${value === o.key
            ? 'bg-[#005F73] text-white border-[#005F73]'
            : 'bg-white text-zinc-700 hover:bg-zinc-50'}`}
          data-testid={`${testPrefix}-filter-${o.key}`}
        >
          {o.label}
          <span className="font-mono ml-1.5 opacity-80">{o.n}</span>
        </button>
      ))}
    </div>
  );
};

export const DiffList = ({ diffs }) => (
  <ul className="space-y-0.5">
    {diffs.map((d) => (
      <li key={d.field} className="text-xs">
        <span className="text-zinc-500">{d.label}:</span>{' '}
        <span className="line-through decoration-zinc-400 text-zinc-600">{String(d.app ?? '—')}</span>
        <span className="mx-1 text-zinc-400">→</span>
        <span className="font-medium text-zinc-900">{String(d.aiq ?? '—')}</span>
      </li>
    ))}
  </ul>
);
